/* global process */
import axios from 'axios'

// Instance
const xhr = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? 'http://fansided.test' : '/',
})

// Middleware
xhr.interceptors.response.use(
    response => response.data,
    error => {
        if (!error.response) return Promise.reject(error.message)
        const { status, data } = error.response

        // eslint-disable-next-line
        return Promise.reject({ status, message: data })
    },
)

export default xhr



// WEBPACK FOOTER //
// ./src/utils/xhr.js